module.exports = __webpack_public_path__ + "img/icn_brand17.0a154cf8.svg";